import { EDIT_CMS_PAGES_META, FETCH_CMS_PAGES_META } from "../actionTypes";

const INITIAL_STATE = {
    isLoading: true,
    page: 1,
    limit: 10,
    total: 0,
    search: '',
    no_Of_pages: 1
};

const fetchPagesMeta = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        
        case FETCH_CMS_PAGES_META:
            return {
                ...state,
                isLoading: false,
                page: action.payload.page,
                limit: action.payload.limit,
                total: action.payload.total,
                search: action.payload.search,
                no_Of_pages: action.payload.no_Of_pages
            };
        
        case EDIT_CMS_PAGES_META:
            return {
                ...state,
                isLoading: false,
                page: state.page,
                limit: state.limit,
                total: action.payload.total,
                search: action.payload.search,
                no_Of_pages: action.payload.no_Of_pages
                // total: state.total + action.payload.total
            };
        
        default:
            return state;
    }
};

export default fetchPagesMeta;